import React, { useContext } from 'react';
import { AppContext } from '../../App';
import HeaderMenu from "../HeaderMenu/HeaderMenu";
import UserMenu from "../UserMenu/UserMenu";
import LoginForm from "../LoginForm/LoginForm";
import Logo from "../../icons/logo.svg";
import UserIcon from "../../icons/user.svg";
import Modal from "../Modal/Modal";
import SubscribersPopup from "../SubscribersPopup/SubscribersPopup";
import NDAPopup from "../NDAPopup/NDAPopup";
import HelpPopup from "../HelpPopup/HelpPopup";
import './PageHeader.styles.scss';

import http, { RESPONSE_TYPES } from "../../core/http";

function PageHeader() {

    const {
        isLoginModalActive,
        isMenuExpanded,
        isSubscribersPopupOpened,
        setIsSubscribersPopupOpened,
        isNDAPopupOpened,
        handleDNAPopupClose,
        handleDNAPopupAccept,
        isHelpPopupOpened,
        setIsHelpPopupOpened,
    } = useContext(AppContext);

    return (
        <div className="page-header" style={{ zIndex: `${isLoginModalActive || isMenuExpanded ? '99' : ''}` }}>
            <div className="page-header__inner">
                <div
                    className="page-header__logo"
                >
                    <div className={`page-logo jalousie ${isMenuExpanded ? 'jalousie--opened' : ''}`}>
                        <a href={process.env.REACT_APP_PORTAL} className="page-logo__link">
                            <Logo className="page-logo__icon"/>
                        </a>
                        <HeaderMenu />
                    </div>
                </div>
                <div className="page-header__children">
                    <div className="page-header__title">Consumer Food Journey<sup>SM</sup></div>
                </div>
                <div className="page-header__wrap">
                    <a
                        href="https://76cc0734.flowpaper.com/IFMAFJIntro/#page=1"
                        className="btn page-header__download-btn"
                        target="_blank"
                    >
                        How to Guide
                    </a>
                    <div className="page-header__user">
                        <div className="page-header__user-btn">
                            <UserIcon/>
                        </div>
                        <UserMenu/>
                    </div>
                </div>
            </div>
            {isLoginModalActive && (
                <LoginForm/>
            )}

            <Modal
                isOpened={isSubscribersPopupOpened}
                close={() => setIsSubscribersPopupOpened(false)}
            >
                <SubscribersPopup
                    close={() => setIsSubscribersPopupOpened(false)}
                />
            </Modal>

            <Modal
                isOpened={isNDAPopupOpened}
                close={handleDNAPopupClose}
            >
                <NDAPopup
                    onProceed={handleDNAPopupAccept}
                    isOpened={isNDAPopupOpened}
                    close={handleDNAPopupClose}
                />
            </Modal>

            <Modal
                isOpened={isHelpPopupOpened}
                close={() => setIsHelpPopupOpened(false)}
            >
                <HelpPopup
                    close={() => setIsHelpPopupOpened(false)}
                />
            </Modal>
        </div>
    );
}

export default PageHeader;